import { EventBus } from "../../../eventbus";
import _ from "lodash";
import { imageExtensions } from "../../../config";
import i18n from "../../../functions/i18next";
import { VueSelecto } from "vue-selecto";
import { getElementInfo } from "moveable";

export default {
  props: {
    doneSearching: Boolean,
    files: {
      type: Array,
      default: () => [],
    },
    mySpace: Number,
    bin: Number,
    isSearch: Boolean,
  },
  components: { VueSelecto },
  data() {
    return {
      id: this.$options.name,
      startRangeId: false,
      views: [
        { name: "list", icon: "listView" },
        { name: "tile", icon: "tileView" },
        { name: "masonry", icon: "masonry" },
      ],
      activeView: "list",
      searchOptions: [
        {
          sortKey: "name",
          name: i18n.t("common.name"),
          class: "name",
          active: true,
        },
        {
          sortKey: "extension",
          name: i18n.t("common.type"),
          class: "ext",
          active: !this.isSearch,
        },
        {
          sortKey: "space",
          name: i18n.tc("spaces.space", 1),
          class: "space",
          active: this.isSearch,
        },
        {
          sortKey: "timestamp",
          name: i18n.t("common.modified"),
          class: "date",
          active: true,
        },

        {
          sortKey: "size",
          name: i18n.t("common.size"),
          class: "size",
          active: true,
        },
      ],
      searchSetting: {
        sortKey: "name",
        isAsc: true,
      },
      allSelected: false,
      getElementInfo: getElementInfo,
    };
  },
  created() {
    //set initactive view
    this.setInitActiveView();

    EventBus.$on(`${this.id}-updateView`, (data) => {
      this.setActiveView(data.view);
      //this.selectAll({ checked: false });
    });

    EventBus.$on(`${this.id}-updatedSearchSettings`, (data) => {
      this.setSearchSettings(data.sortKey);
    });

    EventBus.$on("desktop-file-item--checkItem", this.updateSelected);

    EventBus.$on(`${this.id}--select-range`, this.selectRange);

    EventBus.$on(`desktop-file-holder-selectAll`, (data) => {
      this.updateAllSelected(data);
      this.selectAll(data);
    });
  },
  methods: {
    updateAllSelected(data) {
      if (this.$refs.selecto) {
        let newSelected = [];

        if (data.checked) {
          //add all if checked (else use empty array)
          newSelected = this.files.map((file) => {
            return document.querySelector(
              `.desktop-file-item[data-id="${file.id}"]`
            );
          });
        }

        //set new selected items
        this.$refs.selecto.setSelectedTargets(newSelected);
      }
    },
    updateSelected(data) {
      if (this.$refs.selecto) {
        const newSelected = this.$refs.selecto
          .getSelectedTargets()
          .filter((elem) => elem.dataset.id !== data.file.id);

        if (data.status) {
          newSelected.push(
            document.querySelector(
              `.desktop-file-item[data-id="${data.file.id}"]`
            )
          );
        }

        this.$refs.selecto.setSelectedTargets(newSelected);

        this.setSelectedIdsToTransferItems(
          newSelected.map((itemElem) => itemElem.dataset.id)
        );
      }
    },

    onSelect(e) {
      const selected = e.selected.map((itemElem) => itemElem.dataset.id);
      this.setSelectedIdsToTransferItems(selected);
    },
    setSelectedIdsToTransferItems(ids) {
      //add files to transfer items
      const currentItems = { selectedFiles: [], selectedFolders: [] };

      ids.forEach((id) => {
        const fileOrFolder = this.files.filter((file) => file.id === id)[0];

        if (fileOrFolder) {
          //exists so add it
          if (fileOrFolder.extension) {
            //is file
            currentItems.selectedFiles.push(fileOrFolder);
          } else {
            //is folder
            currentItems.selectedFolders.push(fileOrFolder);
          }
        }
      });

      this.$store.state.transferItems = {
        ...this.$store.state.transferItems,
        ...currentItems,
      };
    },
    setInitActiveView() {
      const tile = JSON.parse(localStorage.getItem("tile"));

      if (tile) {
        this.activeView = tile;
      }
    },

    setActiveView(viewKey) {
      this.activeView = viewKey;
      localStorage.setItem("tile", JSON.stringify(viewKey));
    },

    setSearchSettings(sortKey) {
      //check if already selected
      if (this.searchSetting.sortKey === sortKey) {
        //is selected so just invert
        this.searchSetting.isAsc = !this.searchSetting.isAsc;
      } else {
        //set new values
        this.searchSetting.sortKey = sortKey;
        this.searchSetting.isAsc = true;
      }
    },
    selectAll(data) {
      const selecteditems = {
        selectedFiles: [],
        selectedFolders: [],
      };

      if (data.checked) {
        //sort the files in the correct types
        this.files.forEach((file) => {
          if (file.extension) {
            //is file
            selecteditems.selectedFiles.push(file);
          } else {
            //is folder
            selecteditems.selectedFolders.push(file);
          }
        });

        this.$store.state.transferItems = {
          ...this.$store.state.transferItems,
          ...selecteditems,
        };
      } else {
        this.$store.state.transferItems = {
          selectedFiles: [],
          selectedFolders: [],
          collections: [],
        };
      }
    },

    selectRange(itemData) {
      if (this.startRangeId) {
        //there are more than one item
        //make a list of to select items
        const toSelect = [];

        let addItem = false;
        const endId = itemData.id;

        this.sortedFiles.forEach((file) => {
          if (
            !addItem &&
            (file.id === this.startRangeId || file.id === endId)
          ) {
            addItem = true;
          } else if (
            addItem &&
            (file.id === this.startRangeId || file.id === endId)
          ) {
            addItem = false;
          } else if (addItem) {
            toSelect.push(file.id);
          }
        });

        EventBus.$emit("desktop-file-item--select", toSelect);

        this.startRangeId = false;
      } else {
        this.startRangeId = itemData.id;
      }
    },

    createInitSelectedItem() {
      const filesAndFolders = [
        ...this.$store.state.transferItems.selectedFiles,
        ...this.$store.state.transferItems.selectedFolders,
      ];
      return this.files.map((file) => {
        return {
          ...file,
          checked:
            filesAndFolders.filter((item) => item.id === file.id).length > 0,
        };
      });
    },
  },
  computed: {
    sortedFiles() {
      //add init selected
      const items = this.createInitSelectedItem();

      if (this.activeView !== "masonry") {
        const files = [];
        const folders = [];

        items.forEach((item) => {
          if (item.extension) {
            //add to files array
            files.push(item);
          } else {
            //add to folders array
            folders.push(item);
          }
        });

        //set folders first at all times
        return [
          ..._.orderBy(
            folders,
            this.searchSetting.sortKey,
            this.searchSetting.isAsc ? "asc" : "desc"
          ),
          ..._.orderBy(
            files,
            this.searchSetting.sortKey,
            this.searchSetting.isAsc ? "asc" : "desc"
          ),
        ];
      } else {
        const images = [];
        const other = [];

        items.forEach((item) => {
          let result = false;

          imageExtensions.forEach((ext) => {
            if (item.extension === ext) {
              result = true;
            }
          });

          if (result) {
            //add to images array
            images.push(item);
          } else {
            //add to other array
            other.push(item);
          }
        });

        return [
          ..._.orderBy(
            images,
            this.searchSetting.sortKey,
            this.searchSetting.isAsc ? "asc" : "desc"
          ),
          ..._.orderBy(
            other,
            this.searchSetting.sortKey,
            this.searchSetting.isAsc ? "asc" : "desc"
          ),
        ];
      }
    },
  },
  watch: {
    files() {},
    doneSearching() {},
    $route(newRoute, oldRoute) {
      if (
        this.searchSetting.sortKey !== this.searchOptions[0].sortKey &&
        oldRoute.params.id !== newRoute.params.id
      ) {
        this.setSearchSettings(this.searchOptions[0].sortKey);
      }
    },
  },
};
